
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const Services = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="font-poppins font-bold text-4xl mb-4">Services</h1>
          <p className="font-inter text-xl text-gray-600">
            Browse all available services
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="font-poppins text-2xl">Available Services</CardTitle>
            <CardDescription className="font-inter">
              Find the services you need
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-center py-8 text-gray-500 font-inter">
              Services will be displayed here.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Services;
